import type { CityInfo, CountryInfo, RegionInfo } from '@/shared/api/experience';
import { type LocationType } from '@/entities/location';
import { generateExperienceBreadcrumbs } from './generate-experience-breadcrumbs.ts';
import type { Breadcrumb } from '../../types.ts';

export interface GenerateBreadcrumbsParams {
  currentTag: string;
  geoObject: RegionInfo | CityInfo | CountryInfo;
  country?: string;
  citySlug?: string;
  cityName?: string;
  regionSlug?: string;
  regionName?: string;
  countryName?: string;
  rubric?: string | null;
  rubricTitlesMap: Record<string, string>;
  locationType: LocationType;
  isExperienceDetailsPage?: boolean;
}

export function generateBreadcrumbs(params: GenerateBreadcrumbsParams): Breadcrumb[] {
  return generateExperienceBreadcrumbs(params);
}

export function createRubricTitlesMap(
  tags: Array<{ slug?: string; tag_slug?: string; name?: string }> = [],
): Record<string, string> {
  return tags.reduce(
    (acc, tag) => {
      const slug = 'tag_slug' in tag && tag.tag_slug ? tag.tag_slug : tag.slug;
      const name = tag.name;
      if (slug && name) {
        acc[slug] = name;
      }

      return acc;
    },
    {} as Record<string, string>,
  );
}
